import RewardScarcity from "@Shared/enums/RewardScarcity";

export type BybListItemBackgroundColorGradient = "blue" | "green" | "orange" | "purple" | "red";

export const BybRewardColor: { [key: string]: BybListItemBackgroundColorGradient } = {
  [RewardScarcity.COMMON]: "red",
  [RewardScarcity.UNCOMMON]: "blue",
  [RewardScarcity.RARE]: "orange",
  [RewardScarcity.EPIC]: "purple",
  [RewardScarcity.LEGENDARY]: "green",
};
